import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { formatDate } from "@/lib/api";

export const ThermalLabel = ({ job, width = 80, remark, onRemark, editable }) => {
  const url = `${window.location.origin}/scan/${job.id}`;
  const w = width === 58 ? "58mm" : "80mm";
  const small = width === 58;
  const specs = [
    ...Object.entries(job.specs || {}),
    ...(!job.specs || !Object.keys(job.specs).length ? [["Material", job.material], ["Size", job.dimensions], ["Finishing", job.finishing]] : []),
  ].filter(([, v]) => v);
  const urgent = job.process_time && job.process_time !== "Normal Job";

  return (
    <div className="thermal-label bg-white text-black font-mono mx-auto" style={{ width: w, padding: small ? "2mm" : "3mm" }} data-testid={`thermal-label-${job.job_number}`}>
      <div className="flex items-center justify-between border-b-2 border-black pb-1">
        <div>
          <div className="text-[9px] uppercase tracking-widest">Rozfa Printing</div>
          <div className={`${small ? "text-base" : "text-xl"} font-black leading-tight`}>{job.job_number}</div>
        </div>
        <QRCodeSVG value={url} size={small ? 64 : 84} level="H" includeMargin data-testid={`label-qr-${job.job_number}`} />
      </div>
      <div className="flex justify-between items-center text-[10px] py-1 border-b border-dashed border-black">
        <span className="font-bold uppercase">{job.status}</span>
        <span className={`px-1 font-bold ${urgent ? "bg-black text-white" : "border border-black"}`}>{job.process_time || "Normal Job"}</span>
      </div>
      <div className="py-1 text-[11px] leading-snug border-b border-dashed border-black">
        <div className="font-bold text-[12px]">{job.customer_name}</div>
        {job.customer_phone && <div>{job.customer_phone}</div>}
        {job.agent_name && <div className="text-[10px]">via Agent: {job.agent_company || job.agent_name}{job.agent_phone ? ` • ${job.agent_phone}` : ""}</div>}
      </div>
      <div className="py-1 text-[11px] leading-snug border-b border-dashed border-black">
        {job.items?.length > 1 ? job.items.map((it, i) => (
          <div key={i} className="mb-1" data-testid={`label-item-${i}`}>
            <div className="flex justify-between gap-2 font-bold text-[12px]"><span>{i + 1}. {it.product}</span><span>× {it.quantity}</span></div>
            {Object.entries(it.specs || {}).map(([k, v]) => <div key={k} className="flex justify-between gap-2"><span>{k}</span><span className="font-bold text-right">{v}</span></div>)}
          </div>
        )) : <>
        <div className="font-bold text-[12px]">{job.product}</div>
        {specs.map(([k, v]) => <div key={k} className="flex justify-between gap-2"><span>{k}</span><span className="font-bold text-right">{v}</span></div>)}
        <div className="flex justify-between gap-2"><span>Qty</span><span className="font-bold">{job.quantity}</span></div></>}
        {job.delivery_method && <div className="flex justify-between gap-2"><span>Delivery</span><span className="font-bold">{job.delivery_method}</span></div>}
      </div>
      <div className="py-1 text-[10px] leading-snug border-b border-dashed border-black">
        <div className="flex justify-between"><span>Due</span><span className="font-bold">{formatDate(job.deadline)}</span></div>
        <div className="flex justify-between"><span>Opened</span><span>{formatDate(job.created_at)}</span></div>
        {job.pic_name && <div className="flex justify-between"><span>PIC</span><span>{job.pic_name}</span></div>}
      </div>
      {job.notes && <div className="py-1 text-[10px] border-b border-dashed border-black"><span className="font-bold">Notes:</span> {job.notes}</div>}
      <div className="pt-1">
        <div className="text-[9px] uppercase font-bold tracking-widest">Remark</div>
        {editable ? (
          <textarea value={remark || ""} onChange={(e) => onRemark(e.target.value)} rows={2} placeholder="Type remark for this label..." className="print:hidden w-full text-[11px] border border-black p-1 rounded-none bg-yellow-50 focus:outline-none" data-testid={`label-remark-input-${job.job_number}`} />
        ) : null}
        {remark && <div className="hidden print:block text-[11px] font-bold border border-black p-1 whitespace-pre-wrap">{remark}</div>}
        <div className="remark-lines mt-1">
          <div className="border-b border-black h-[7mm]" /><div className="border-b border-black h-[7mm]" /><div className="border-b border-black h-[7mm]" />
        </div>
        <div className="flex justify-between text-[9px] mt-1"><span>Checked by: ________</span><span>Date: ________</span></div>
        <div className="text-[8px] text-center mt-1 font-mono">Scan QR → job status &amp; details</div>
      </div>
    </div>
  );
};
